/* ============================================================
   Refurb Technology — theme.js
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(cents / 100);

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const open = nav.classList.toggle('site-nav--open');
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  const drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() { drawer && drawer.classList.add('is-open'); }
  function closeDrawer() { drawer && drawer.classList.remove('is-open'); }

  if (drawer) {
    drawer.querySelectorAll('[data-cart-close]').forEach((el) =>
      el.addEventListener('click', closeDrawer)
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.preventDefault();
      refreshCart().then(openDrawer);
    })
  );

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      updateCount(cart.item_count);
      return cart;
    } catch (err) {
      console.error('Cart fetch error', err);
    }
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    const list = drawer && drawer.querySelector('[data-cart-items]');
    const foot = drawer && drawer.querySelector('[data-cart-foot]');
    if (!list) return;

    if (cart.item_count === 0) {
      list.innerHTML =
        '<div class="cart-drawer__empty"><p>Votre panier est vide.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-item" data-line-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_140x$1') : ''}" alt="${item.product_title}" loading="lazy">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="qty" style="margin-top:8px">
            <button type="button" data-qty-change="-1" data-key="${item.key}" aria-label="Diminuer">−</button>
            <input type="text" value="${item.quantity}" readonly aria-label="Quantité">
            <button type="button" data-qty-change="1" data-key="${item.key}" aria-label="Augmenter">+</button>
          </div>
          <button class="cart-item__remove" data-remove="${item.key}">Retirer</button>
        </div>
        <div class="price" style="font-size:1rem">${money(item.final_line_price)}</div>
      </div>`
      )
      .join('');

    const sub = drawer.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);

    list.querySelectorAll('[data-qty-change]').forEach((btn) =>
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const item = cart.items.find((i) => i.key === key);
        if (!item) return;
        changeLine(key, item.quantity + parseInt(btn.dataset.qtyChange, 10));
      })
    );
    list.querySelectorAll('[data-remove]').forEach((btn) =>
      btn.addEventListener('click', () => changeLine(btn.dataset.remove, 0))
    );
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      renderCart(cart);
      updateCount(cart.item_count);
    } catch (err) {
      console.error(err);
    }
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      try {
        const mainId = form.querySelector('[name="id"]').value;
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
        const properties = {};
        form.querySelectorAll('[data-property-select]').forEach((sel) => {
          if (sel.value) {
            const key = sel.name.replace('properties[', '').replace(']', '');
            properties[key] = sel.value;
          }
        });
        const addonItems = [];
        form.querySelectorAll('[data-addon]').forEach((cb) => {
          if (!cb.checked) return;
          if (cb.dataset.addonVariant) {
            addonItems.push({ id: parseInt(cb.dataset.addonVariant, 10), quantity: qty });
          } else if (cb.dataset.property) {
            properties[cb.dataset.property] = 'Oui';
          }
        });
        const items = [{ id: mainId, quantity: qty, properties: properties }];
        addonItems.forEach((i) => items.push(i));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openDrawer();
      } catch (err) {
        console.error(err);
        alert("Impossible d'ajouter cet article au panier.");
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });

  /* ============================================================
     PRODUCT PAGE — variants + gallery + qty
     ============================================================ */
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const dataEl = document.querySelector('[data-variants-json]');
    let variants = [];
    try { variants = JSON.parse(dataEl?.textContent || '[]'); } catch (e) {}

    const idInput = productForm.querySelector('[name="id"]');
    const optionInputs = productForm.querySelectorAll('[data-option-input]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const addBtn = productForm.querySelector('[data-add-btn]');

    function selectedOptions() {
      const opts = {};
      optionInputs.forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        opts[input.dataset.optionPosition] = input.value;
      });
      return opts;
    }

    function findVariant() {
      const opts = selectedOptions();
      return variants.find((v) =>
        v.options.every((val, i) => opts[i + 1] === val)
      );
    }

    function updateSelectedLabels() {
      document.querySelectorAll('[data-selected-for]').forEach((label) => {
        const pos = label.dataset.selectedFor;
        const checked = productForm.querySelector(
          `[data-option-position="${pos}"]:checked, [data-option-position="${pos}"]`
        );
        if (checked) label.textContent = checked.value;
      });
    }

    function updateAvailability() {
      const current = selectedOptions();
      optionInputs.forEach((input) => {
        const pos = parseInt(input.dataset.optionPosition, 10);
        const val = input.value;
        const exists = variants.some((v) => {
          if (!v.available) return false;
          if (v.options[pos - 1] !== val) return false;
          return v.options.every((ov, i) => {
            const p = i + 1;
            if (p === pos) return true;
            return current[p] === undefined || current[p] === ov;
          });
        });
        const wrapper = input.closest('.variant-swatch, .variant-pill');
        if (wrapper) wrapper.classList.toggle('is-unavailable', !exists);
      });
    }

    function update() {
      const variant = findVariant();
      updateSelectedLabels();
      updateAvailability();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponible'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Rupture de stock';
      }
      if (variant.featured_media) {
        showImage(variant.featured_media.id);
      }
      currentPrice = variant.price;
      updateOptionsTotal();
    }

    let currentPrice = 0;
    const totalEl = document.querySelector('[data-options-total]');
    const addonInputs = productForm.querySelectorAll('[data-addon]');

    function updateOptionsTotal() {
      if (!totalEl) return;
      let extra = 0;
      let any = false;
      addonInputs.forEach((cb) => {
        if (cb.checked && cb.dataset.price) {
          const p = parseFloat(cb.dataset.price) * 100;
          if (p > 0) { extra += p; any = true; }
        }
      });
      if (any) {
        totalEl.hidden = false;
        totalEl.innerHTML = 'Total avec options : <strong>' + money(currentPrice + extra) + '</strong>';
      } else {
        totalEl.hidden = true;
      }
    }

    addonInputs.forEach((cb) => cb.addEventListener('change', updateOptionsTotal));
    optionInputs.forEach((input) =>
      input.addEventListener('change', update)
    );
    update();
  }

  /* ---------- Gallery ---------- */
  const mainImg = document.querySelector('[data-main-image]');
  function showImage(mediaId) {
    const thumb = document.querySelector(`[data-media-id="${mediaId}"]`);
    if (thumb && mainImg) {
      const full = thumb.dataset.full;
      if (full) mainImg.src = full;
      document.querySelectorAll('[data-media-id]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }
  document.querySelectorAll('[data-media-id]').forEach((thumb) =>
    thumb.addEventListener('click', () => showImage(thumb.dataset.mediaId))
  );

  /* ---------- Quantity steppers (product page) ---------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) =>
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.step, 10);
        const val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
      })
    );
  });

  /* ============================================================
     DEVICE FINDER (sélecteur d'appareil)
     ============================================================ */
  function fillBrandSelect(select) {
    const devices = window.REFURB_DEVICES || {};
    Object.keys(devices).forEach((brand) => {
      const opt = document.createElement('option');
      opt.value = brand; opt.textContent = brand;
      select.appendChild(opt);
    });
  }
  function fillModelSelect(select, brand) {
    const devices = window.REFURB_DEVICES || {};
    select.innerHTML = '<option value="">Choisir un modèle…</option>';
    if (brand && devices[brand]) {
      Object.keys(devices[brand]).forEach((model) => {
        const opt = document.createElement('option');
        opt.value = model; opt.textContent = model;
        select.appendChild(opt);
      });
      select.disabled = false;
    } else {
      select.disabled = true;
    }
  }

  document.querySelectorAll('[data-device-finder]').forEach((finder) => {
    const brandSel = finder.querySelector('[data-df-brand]');
    const modelSel = finder.querySelector('[data-df-model]');
    fillBrandSelect(brandSel);
    brandSel.addEventListener('change', () => fillModelSelect(modelSel, brandSel.value));

    finder.querySelectorAll('[data-df-action]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const action = link.dataset.dfAction;
        const base = link.dataset.url || '/search';
        const brand = brandSel.value;
        const model = modelSel.value;
        if (!brand || !model) {
          brandSel.focus();
          finder.classList.add('shake');
          setTimeout(() => finder.classList.remove('shake'), 500);
          return;
        }
        const q = encodeURIComponent(brand + ' ' + model);
        let url = base;
        if (action === 'buy') {
          url = base.indexOf('?') > -1 ? base + '&q=' + q : (base.split('?')[0] || '/search') + '?q=' + q;
        } else if (action === 'tradein') {
          url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'marque=' + encodeURIComponent(brand) + '&modele=' + encodeURIComponent(model);
        } else if (action === 'repair') {
          url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'modele=' + q;
        }
        window.location.href = url;
      });
    });
  });

  /* ============================================================
     TRADE-IN (reprise) — étapes + estimation
     ============================================================ */
  const tradeForm = document.querySelector('.tradein__form');
  if (tradeForm && window.REFURB_DEVICES) {
    const brandSel = tradeForm.querySelector('[data-ti-brand]');
    const modelSel = tradeForm.querySelector('[data-ti-model]');
    const steps = tradeForm.querySelectorAll('[data-step]');
    const stepbars = document.querySelectorAll('[data-stepbar]');

    if (brandSel) {
      fillBrandSelect(brandSel);
      brandSel.addEventListener('change', () => fillModelSelect(modelSel, brandSel.value));

      const params = new URLSearchParams(window.location.search);
      const pBrand = params.get('marque');
      const pModel = params.get('modele');
      if (pBrand && window.REFURB_DEVICES[pBrand]) {
        brandSel.value = pBrand;
        fillModelSelect(modelSel, pBrand);
        if (pModel) modelSel.value = pModel;
      }
    }

    function showStep(n) {
      steps.forEach((s) => { s.hidden = s.dataset.step !== String(n); });
      stepbars.forEach((b) => b.classList.toggle('is-active', parseInt(b.dataset.stepbar, 10) <= n));
      tradeForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    tradeForm.querySelectorAll('[data-ti-next]').forEach((b) =>
      b.addEventListener('click', () => {
        if (!brandSel.value || !modelSel.value) {
          alert('Sélectionnez la marque et le modèle de votre appareil.');
          return;
        }
        showStep(2);
      })
    );
    tradeForm.querySelectorAll('[data-ti-prev]').forEach((b) =>
      b.addEventListener('click', () => {
        const current = [...steps].find((s) => !s.hidden);
        showStep(Math.max(1, parseInt(current.dataset.step, 10) - 1));
      })
    );

    tradeForm.querySelectorAll('[data-ti-estimate]').forEach((b) =>
      b.addEventListener('click', () => {
        const groups = tradeForm.querySelectorAll('[data-step="2"] fieldset');
        let allAnswered = true;
        let coef = 1;
        groups.forEach((fs) => {
          const checked = fs.querySelector('input:checked');
          if (!checked) { allAnswered = false; return; }
          coef *= parseFloat(checked.dataset.coef);
        });
        if (!allAnswered) { alert('Merci de répondre à toutes les questions.'); return; }

        const base = (window.REFURB_DEVICES[brandSel.value] || {})[modelSel.value] || 0;
        const amountEl = tradeForm.querySelector('[data-ti-amount]');
        const deviceHidden = tradeForm.querySelector('[data-ti-device-hidden]');
        const amountHidden = tradeForm.querySelector('[data-ti-amount-hidden]');
        const device = brandSel.value + ' ' + modelSel.value;
        if (deviceHidden) deviceHidden.value = device;

        if (coef === 0) {
          if (amountEl) amountEl.textContent = 'Non reprenable en l’état';
          if (amountHidden) amountHidden.value = 'Non reprenable (verrouillé)';
        } else {
          const est = Math.round(base * coef);
          const low = Math.max(5, Math.round(est * 0.85));
          const txt = low === est ? est + ' €' : low + ' € – ' + est + ' €';
          if (amountEl) amountEl.textContent = txt;
          if (amountHidden) amountHidden.value = txt;
        }
        showStep(3);
      })
    );
  }

  /* Initial cart count sync */
  refreshCart();
})();
